(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-modern"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.contact-modern');
    if (!sections.length) return;

    sections.forEach(section => {
      const form = section.querySelector('.contact-modern__form');
      const submitBtn = section.querySelector('[data-submit]');
      const successEl = section.querySelector('[data-success]');
      const errorEl = section.querySelector('.contact-modern__alert--error');

      // Scroll to success/error after submission
      if (successEl) {
        setTimeout(() => successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
      }
      if (errorEl) {
        setTimeout(() => errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
      }

      // Character counter
      section.querySelectorAll('[data-char-count]').forEach(el => {
        const field = el.closest('.contact-modern__field');
        const counter = field && field.querySelector('[data-count]');
        if (!counter) return;
        const update = () => counter.textContent = el.value.length;
        el.addEventListener('input', update);
        update();
      });

      // Submit loading state
      if (form && submitBtn) {
        form.addEventListener('submit', () => {
          if (form.checkValidity && !form.checkValidity()) return;
          submitBtn.classList.add('is-loading');
          submitBtn.disabled = true;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-modern"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.faq-modern');
    if (!sections.length) return;

    sections.forEach(section => {
      // ─── Smooth accordion (animation max-height fluide même avec <details>) ───
      section.querySelectorAll('.faq-item').forEach(item => {
        const summary = item.querySelector('.faq-item__summary');
        if (!summary) return;
        summary.addEventListener('click', (e) => {
          // Ferme les autres si on veut un accordéon "single open"
          // (commenté car pas activé par défaut — décommente si tu veux ce comportement)
          // if (!item.open) {
          //   section.querySelectorAll('.faq-item[open]').forEach(other => {
          //     if (other !== item) other.removeAttribute('open');
          //   });
          // }
        });
      });

      // ─── Recherche ───
      const input = section.querySelector('[data-faq-search]');
      const clearBtn = section.querySelector('[data-faq-clear]');
      const emptyMsg = section.querySelector('[data-faq-empty]');
      const items = section.querySelectorAll('[data-faq-item]');
      const categories = section.querySelectorAll('.faq-category');

      if (!input) return;

      const filter = (query) => {
        const q = (query || '').toLowerCase().trim();
        let visibleCount = 0;

        items.forEach(item => {
          const text = item.dataset.faqText || '';
          const match = q === '' || text.indexOf(q) !== -1;
          item.hidden = !match;
          if (match) visibleCount++;
        });

        // Masquer les catégories sans aucune question visible
        categories.forEach(cat => {
          let next = cat.nextElementSibling;
          let hasVisible = false;
          while (next && !next.classList.contains('faq-category')) {
            if (next.matches('[data-faq-item]') && !next.hidden) { hasVisible = true; break; }
            next = next.nextElementSibling;
          }
          cat.hidden = !hasVisible;
        });

        if (emptyMsg) emptyMsg.hidden = visibleCount > 0;
        if (clearBtn) clearBtn.hidden = q === '';
      };

      input.addEventListener('input', (e) => filter(e.target.value));
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          input.value = '';
          filter('');
          input.focus();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-personnalisation"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.form-perso');
    if (!sections.length) return;

    sections.forEach(section => {
      const form = section.querySelector('.form-perso__form');
      const progressBar = section.querySelector('[data-progress-bar]');
      const progressText = section.querySelector('[data-progress-text]');
      const submitBtn = section.querySelector('[data-submit]');
      const successEl = section.querySelector('[data-success]');

      // Auto-scroll to success/error message on Shopify form re-render
      if (successEl) {
        setTimeout(() => successEl.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
      }
      const errorEl = section.querySelector('.form-perso__alert--error');
      if (errorEl) {
        setTimeout(() => errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
      }

      // Progress bar
      const trackedFields = section.querySelectorAll('[data-progress-field]');
      const fieldNames = new Set();
      trackedFields.forEach(f => fieldNames.add(f.name));
      const totalFields = fieldNames.size;

      const updateProgress = () => {
        const filled = new Set();
        trackedFields.forEach(f => {
          if (f.type === 'radio' || f.type === 'checkbox') {
            if (f.checked) filled.add(f.name);
          } else if (f.value && f.value.trim()) {
            filled.add(f.name);
          }
        });
        const pct = totalFields === 0 ? 0 : Math.round((filled.size / totalFields) * 100);
        if (progressBar) progressBar.style.width = pct + '%';
        if (progressText) progressText.textContent = pct + ' %';
      };

      trackedFields.forEach(f => {
        f.addEventListener('input', updateProgress);
        f.addEventListener('change', updateProgress);
      });
      updateProgress();

      // Character counters
      section.querySelectorAll('[data-char-count]').forEach(el => {
        const field = el.closest('.form-perso__field');
        const counter = field && field.querySelector('[data-count]');
        if (!counter) return;
        const update = () => counter.textContent = el.value.length;
        el.addEventListener('input', update);
        update();
      });

      // File upload (drag & drop + previews)
      const uploadInput = section.querySelector('[data-upload-input]');
      const uploadZone = section.querySelector('[data-upload-zone]');
      const filesList = section.querySelector('[data-upload-files]');

      if (uploadInput && uploadZone && filesList) {
        const MAX_FILES = 5;
        let currentFiles = [];

        const renderFiles = () => {
          filesList.innerHTML = '';
          currentFiles.forEach((file, idx) => {
            const chip = document.createElement('div');
            chip.className = 'form-perso__upload-file';
            chip.innerHTML = `<span>${file.name}</span><button type="button" aria-label="Retirer">×</button>`;
            chip.querySelector('button').addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              currentFiles.splice(idx, 1);
              syncInput();
              renderFiles();
            });
            filesList.appendChild(chip);
          });
        };

        const syncInput = () => {
          const dt = new DataTransfer();
          currentFiles.forEach(f => dt.items.add(f));
          uploadInput.files = dt.files;
        };

        const handleFiles = (fileList) => {
          Array.from(fileList).forEach(f => {
            if (currentFiles.length < MAX_FILES) currentFiles.push(f);
          });
          syncInput();
          renderFiles();
        };

        uploadInput.addEventListener('change', () => handleFiles(uploadInput.files));

        ['dragenter', 'dragover'].forEach(ev => {
          uploadZone.addEventListener(ev, (e) => {
            e.preventDefault();
            e.stopPropagation();
            uploadZone.classList.add('is-dragover');
          });
        });

        ['dragleave', 'drop'].forEach(ev => {
          uploadZone.addEventListener(ev, (e) => {
            e.preventDefault();
            e.stopPropagation();
            uploadZone.classList.remove('is-dragover');
          });
        });

        uploadZone.addEventListener('drop', (e) => {
          if (e.dataTransfer && e.dataTransfer.files) handleFiles(e.dataTransfer.files);
        });
      }

      // Submit loading state (only if form is valid)
      if (form && submitBtn) {
        form.addEventListener('submit', (e) => {
          if (form.checkValidity && !form.checkValidity()) return;
          submitBtn.classList.add('is-loading');
          submitBtn.disabled = true;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-showcase"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.partner-showcase');
    if (!sections.length) return;

    sections.forEach(section => {
      // Reveal on scroll — only opt-in once we know JS is running.
      // If anything fails, content stays visible (default state).
      const revealItems = section.querySelectorAll('[data-reveal]');
      const inShopifyEditor = window.Shopify && window.Shopify.designMode;

      if ('IntersectionObserver' in window && !inShopifyEditor) {
        section.classList.add('is-animated');
        const io = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });
        revealItems.forEach(el => io.observe(el));

        // Safety net: if nothing fired within 1.5s, reveal everything.
        setTimeout(() => {
          revealItems.forEach(el => el.classList.add('is-visible'));
        }, 1500);
      }

      // Copy promo code
      const promoBtn = section.querySelector('.partner-promo__code');
      if (promoBtn) {
        const originalLabel = promoBtn.querySelector('.partner-promo__copy-text');
        promoBtn.addEventListener('click', async () => {
          const code = promoBtn.dataset.promoCode;
          if (!code) return;
          try {
            await navigator.clipboard.writeText(code);
          } catch (e) {
            const ta = document.createElement('textarea');
            ta.value = code;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); } catch (_) {}
            document.body.removeChild(ta);
          }
          promoBtn.classList.add('is-copied');
          if (originalLabel) originalLabel.textContent = 'Copié !';
          setTimeout(() => {
            promoBtn.classList.remove('is-copied');
            if (originalLabel) originalLabel.textContent = 'Copier';
          }, 1800);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
